export var AnimationType;
(function (AnimationType) {
  AnimationType[AnimationType["forwardImmediateBack"] = 0] = "forwardImmediateBack";
  AnimationType[AnimationType["forwardWaitForBack"] = 1] = "forwardWaitForBack";
})(AnimationType || (AnimationType = {}));